export const environment = {
    production: false,
    baseURL:"https://ppe-stopover.adminmodules.etihad.ae/ada-services/stopoveradmin",
    OKTAClientID:"0oa21igtki7vjEZ5o0h8",
    OKTAIssuer:"https://etihad.oktapreview.com",
    OKTArediRectUri:"https://ppe-stopover.adminmodules.etihad.ae/login/callback",
    coreDataURL:"https://www.etihad.com",
    env:"PPE"
};
